import { CreditCardAddressSettings } from './type';

export const creditCardAddressSettings: CreditCardAddressSettings = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        regular: {
          color: 'gray.dark',
        },
      },
    },
  },
};
